import { getActiveLanguage, getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import React from 'react';
import { Table } from 'react-bootstrap';
import TextArea from '../components/forms/TextArea';

class InstallationServiceParking extends React.Component {
  render() {
    const {
      translate,
      parkingInfo,
      onParkingInfoChanged,
    } = this.props;

    return (
      <div>
        <Table className="table-width" bordered>
          <thead className="table-head">
            <tr>
              <th>{translate('service_installation.installation_parking_info')}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div className="row">
                  <div className="col-sm-8 col-md-offset-2">
                    <TextArea
                    name="installationComments"
                    value={parkingInfo}
                    onChange={onParkingInfoChanged}
                    rows={3} />
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    );
  }
}

const mapStateToProps = (state = {}) => {
  const locale = state.locale || {};
  const activeLang = getActiveLanguage(locale);

  return {
    currentLanguage: (activeLang && activeLang.code) || 'fi',
    translate: getTranslate(locale),
    session: state.session.session || {},
  };
};

export default connect(
  mapStateToProps,
  null,
)(InstallationServiceParking);
